<script>
/**
 * ****************************************************************************
 * @description     :   Input File Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input file component
 */
var AnsFile = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        placeholder: String,
        modelValue: Object,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        onChange: Function,
        onFocus: Function,
        onBlur: Function
    },
    emits: ['update:modelValue'],
    methods: {
        /**
         * event forcus on input file
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        focusInput(e) {
            if (this.onFocus) {
                this.onFocus(e);
            }
        },
        /**
         * event blur on input file
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        blurInput(e) {
            if (this.onBlur) {
                this.onBlur(e);
            }
        },
        /**
         * update input file
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        updateInput(e) {
            this.$emit('update:modelValue', e.target.files[0]);
            if (this.onChange) {
                this.onChange(e);
            }
        }
    }
};
export default AnsFile;
</script>
